import { render } from "./CrudComentarioPregunta.vue?vue&type=template&id=0e651f5a"
import script from "./CrudComentarioPregunta.vue?vue&type=script&lang=js"
export * from "./CrudComentarioPregunta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__